<template>
    <div class="reset-password-wrapper">
        <div class="login-container" v-if="!resetPasswordSuccess">
            <h2>Reset Password</h2>
            <div class="forgotpass-subtitle">Almost done! Enter your new password and you are good to go.</div>

            <v-text-field
                v-model="resetPassword"
                :append-icon="securePassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min]"
                :type="securePassword ? 'password' : 'text'"
                name="input-10-1"
                label="Password"
                hint="At least 8 characters"
                class="pass-input"
                counter
                @click:append="securePassword = !securePassword"
            ></v-text-field>

            <v-text-field
                v-model="resetPasswordConfirm"
                :append-icon="securePasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min, rules.samePass]"
                :type="securePasswordConfirm ? 'password' : 'text'"
                name="input-10-2"
                label="Confirm password"
                hint="At least 8 characters"
                class="pass-input"
                counter
                @click:append="securePasswordConfirm = !securePasswordConfirm"
            ></v-text-field>

            <div class="login-btn-wrapper">
                <v-btn class="submit" v-on:click="() => submitResetPassword()">Reset password</v-btn>
            </div>
        </div>

        <div class="login-container" v-else>
            <img src="../assets/success.png" class="success-img"/>
            <div class="success-title">Your password has been changed successfully!</div>
        </div>
    </div>
</template>


<script>
    import {required, minLength, sameAs} from 'vuelidate/lib/validators';
    import axios from "axios";

    export default {
        name: "ResetPassword",
        head: {
            title: 'Reset your password | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
        },
        validations: {
            resetPassword: {
                required,
                minLength: minLength(8)
            },
            resetPasswordConfirm: {
                sameAsPassword: sameAs('resetPassword')
            }
        },
        data() {
            return {
                resetPassword: "",
                resetPasswordConfirm: "",
                resetPasswordCode: "",
                resetPasswordEmail: "",
                securePassword: true,
                securePasswordConfirm: true,
                resetPasswordSuccess: false,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    samePass: value => value === this.resetPassword || 'Confirm password doesn\'t match'
                },
                valid: true
            }
        },
        methods: {
            submitResetPassword() {
                let resetPassThis = this;

                if (this.resetPassword && this.resetPasswordConfirm && !this.$v.resetPassword.$invalid && !this.$v.resetPasswordConfirm.$invalid) {
                    axios.put('https://auth.vindome.net/api/ResetPassword', {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                        },
                        email: resetPassThis.resetPasswordEmail,
                        password: resetPassThis.resetPassword,
                        confirmPassword: resetPassThis.resetPasswordConfirm,
                        code: resetPassThis.resetPasswordCode
                    }).then(function (response) {
                        resetPassThis.resetPasswordSuccess = true;
                    }).catch(function (err) {
                        resetPassThis.resetPasswordSuccess = false;
                    });
                }
            },
        },
        mounted() {
            this.resetPasswordCode = this.$route.query.code;
            this.resetPasswordEmail = this.$route.query.email;
        }
    }
</script>

<style scoped>
    body {
        font-family: 'Poppins', sans-serif;
        font-size: 14px;
        color: #FFF;
    }

    input, button {
        border: none;
        outline: none;
        background: none;
        font-family: 'Poppins', sans-serif;
    }

    .login-container {
        max-width: 600px;
        margin: 100px auto;
        background: #fff;
        padding: 50px;
        border: 2px solid #F3F4F7;
        font-family: 'Poppins', sans-serif;
    }

    .home-wrapper {
        font-size: 14px;
        font-family: 'Poppins', sans-serif;
        background: #ffffff;
    }

    button {
        display: block;
        margin: 0 auto;
        width: 260px;
        height: 36px;
        border-radius: 30px;
        color: #fff;
        font-size: 15px;
        cursor: pointer;
    }

    h2 {
        width: 100%;
        font-size: 30px;
        margin-bottom: 30px;
        font-weight: 600;
    }

    input {
        display: block;
        width: 100%;
        font-size: 16px;
        border-bottom: 2px solid #E0E0E0;
        height: 60px;
    }

    input[type="text"] {
        margin-bottom: 40px;
    }

    .submit {
        margin-bottom: 20px;
        background: #024E7B !important;
        color: #FFF !important;
        width: 180px;
        height: 47px !important;
        font-size: 15px;
        border-radius: 25px;
        float: left;
        font-weight: 400;
    }

    .fb-btn span {
        font-weight: bold;
        color: #455a81;
    }

    .icon-link img {
        width: 100%;
        vertical-align: top;
    }

    .pass-input {
        margin-bottom: 20px;
        font-size: 14px;
    }

    .login-container a {
        color: #013D61;
        text-decoration: none;
        font-size: 15px;
    }

    .login-btn-wrapper {
        height: 50px;
        margin-top: 40px;
    }

    .forgotpass-subtitle {
        margin-bottom: 20px;
    }

    .header-row {
        height: 63px;
        padding-top: 20px;
        position: relative;
    }

    .success-img {
        width: 122px;
        height: 122px;
        margin: 0 auto 30px;
        display: block;
    }

    .success-title {
        font-size: 22px;
        text-align: center;
    }

    .login-container .submit {
        margin-top: 0;
        background: #E1C376 !important;
        color: #FFF !important;
        width: 200px;
        height: 40px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        font-weight: lighter;
        box-shadow: none;
        margin-left: 0;
        margin-right: 0;
    }

    @media (max-width: 767px) {
        .social span {
            display: none;
        }

        .header-row {
            padding-top: 0;
        }

        .home-wrapper {
            height: 100%;
        }

        .login-container {
            margin: 30px auto;
            padding: 25px;
        }

        .main-wrapper {
            margin-top: 0 !important;
        }

        .reset-password-wrapper {
            padding: 0 15px;
        }
    }
</style>
